'use client'
import { ClickableDecision } from '@/app/api/placements/types'
import { NavigateRightThinIcon } from '@/app/icons/navigate-right-thin'
import Avatar from '@/components/avatar'
import { fireAdTrackingPixel } from '@/util/ad-click'
import { IGif } from '@giphy/js-types'
import { getGifHeight } from '@giphy/js-util'
import { Gif, GifOverlayProps } from '@giphy/react-components'
import dynamic from 'next/dynamic'

const mobileGridGap = 6
export const ctaSectionHeight = 54
export const ctaSectionHeightWithGap = ctaSectionHeight + mobileGridGap

const GifOverlay = dynamic(() => import('@/components/grid/overlay/gif-overlay'), { ssr: false })

type Props = {
    ad: ClickableDecision
    gif: IGif
    width: number
    isMobile: boolean
}

const ClickableAd = ({ ad, gif, width, isMobile }: Props) => {
    const { click_url, click_tracking_url, cta_text, impression_tracking_url: impression_url } = ad
    const onClick = () => {
        fireAdTrackingPixel(click_tracking_url)
        if (click_url) {
            window.open(click_url, '_blank', 'noopener,noreferrer')
        }
    }

    return (
        <div
            className="group absolute left-0 z-10 flex cursor-pointer flex-col overflow-hidden rounded-t-sm md:w-[251px]"
            onClick={onClick}
        >
            <Gif
                gif={gif}
                width={width}
                height={getGifHeight(gif, width)}
                overlay={
                    !isMobile ? (props: GifOverlayProps) => <GifOverlay {...props} hideAttribution={true} /> : undefined
                }
                hideAttribution
                borderRadius={0}
                noLink
                onGifSeen={(_) => {
                    try {
                        if (impression_url) {
                            fireAdTrackingPixel(impression_url)
                        }
                    } catch (_e) {
                        console.error(_e)
                    }
                }}
            />
            <div className="flex h-[55px] w-full items-center gap-2 rounded-b-sm border-r-[1.5px] border-b-[1.5px] border-l-[1.5px] border-giphyDarkGrey bg-giphyBlack px-3 group-hover:bg-giphyWhite/6">
                <Avatar user={gif.user} size={32} className="pointer-events-none" />
                <div className="font-bold group-hover:underline [@media(max-width:336px)]:hidden">{cta_text}</div>
                <NavigateRightThinIcon className="ml-auto size-5 fill-giphyWhite" />
            </div>
        </div>
    )
}

export default ClickableAd
